export const DEFAULT_POLYGON_STYLE = {
  color: '#49e2ce',
  weight: 1.4,
  opacity: 1,
  fillColor: '#1f7f74',
  fillOpacity: 0.24,
} as const;

export const SELECTED_POLYGON_STYLE = {
  color: '#d8fff8',
  weight: 4.2,
  opacity: 1,
  fillColor: '#1f7f74',
  fillOpacity: 0.82,
} as const;
